<label class="form-label">{{ label }}</label>
<input type="text" class="form-control" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (change)="onChange()">
